export const getDisplayNickname = (nickname?: string, name?: string): string => {
  return nickname?.trim() ? nickname : name ?? '';
};